import { useEffect } from "react";

type UseBodyScrollLockParams = {
  enabled: boolean;
  isWeb: boolean;
};

export const useBodyScrollLock = ({
  enabled,
  isWeb,
}: UseBodyScrollLockParams) => {
  useEffect(() => {
    if (
      !enabled ||
      !isWeb ||
      typeof document === "undefined" ||
      typeof window === "undefined"
    ) {
      return;
    }

    const body = document.body;
    const scrollY = window.scrollY;

    const prevPosition = body.style.position;
    const prevTop = body.style.top;
    const prevWidth = body.style.width;
    const prevOverflowY = body.style.overflowY;

    body.style.position = "fixed";
    body.style.top = `-${scrollY}px`;
    body.style.width = "100%";
    body.style.overflowY = "scroll";

    return () => {
      body.style.position = prevPosition;
      body.style.top = prevTop;
      body.style.width = prevWidth;
      body.style.overflowY = prevOverflowY;
      window.scrollTo(0, scrollY);
    };
  }, [enabled, isWeb]);
};
